// extracted by mini-css-extract-plugin
export default {"container":"DropdownMenu-module--container--uOacv","menuItem":"DropdownMenu-module--menuItem--Ktmdi"};